module.exports = __webpack_public_path__ + "img/mobile-devices-2017980_1280.ad6774bc.png";